/* global require, __SKIN__*/
const skinConfig = require("../../skins/" + __SKIN__ + "/config.js");
const Config = require("./conf");
import Helpers from "../helpers/helperFunctions";

Config.env = Config.env || {};

Config.env.os = Helpers.getMobileOperatingSystem();

Helpers.mergeRecursive(Config, skinConfig);

try {
    const Rules = require("../../skins/" + __SKIN__ + "/rules.js");
    Helpers.mergeRecursive(Config, Rules);
} catch (error) {
    //console.error(error);
    console.log('rules.js js not exist in skin');
}
export default Config;